{
  "moreActions": "More actions",
  "unavailable": "Unavailable, expand for details",
  "backButton": "Return to {prevMenuButton}"
}
